import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { ProgressSpinner } from "primereact/progressspinner";
import "./Filter.css";

const FiltersDialog = ({
  visible,
  onHide,
  editingFilter,
  filterName,
  setFilterName,
  selectedForm,
  handleFormChange,
  forms,
  formFields,
  filterRules,
  addRule,
  removeRule,
  updateRule,
  loading,
  onSave,
  onPreview,
}) => {
  const operatorOptions = [
    { label: "Equals", value: "equals" },
    { label: "Not Equals", value: "notEquals" },
    { label: "Contains", value: "contains" },
    { label: "Starts With", value: "startsWith" },
    { label: "Ends With", value: "endsWith" },
  ];

  const getAvailableFields = (currentIndex) => {
    const selectedFields = filterRules
      .map((rule, idx) => (idx !== currentIndex ? rule.field : null))
      .filter(Boolean);

    return formFields.filter((field) => !selectedFields.includes(field.value));
  };

  const handlePreview = () => {
    onPreview(selectedForm.id, filterRules);
  };

  const dialogFooter = (
    <div className="flex justify-content-end gap-2">
      <Button
        label="Cancel"
        icon="pi pi-times"
        onClick={onHide}
        style={{ backgroundColor: "#D97A07", borderColor: "#D97A07" }}
      />
      <Button
        label="Preview"
        icon="pi pi-eye"
        onClick={handlePreview}
        style={{ backgroundColor: "#0D2E4D", borderColor: "#0D2E4D" }}
        disabled={
          !selectedForm ||
          !filterName.trim() ||
          filterRules.every((rule) => !rule.field) ||
          filterRules.some(
            (rule) =>
              rule.field &&
              !["isEmpty", "isNotEmpty"].includes(rule.operator) &&
              !rule.value?.trim()
          )
        }
      />
      <Button
        label={editingFilter ? "Update" : "Create"}
        icon="pi pi-check"
        onClick={onSave}
        style={{ backgroundColor: "#0D2E4D", borderColor: "#0D2E4D" }}
        disabled={
          !selectedForm ||
          !filterName.trim() ||
          filterRules.every((rule) => !rule.field) ||
          filterRules.some(
            (rule) =>
              rule.field &&
              !["isEmpty", "isNotEmpty"].includes(rule.operator) &&
              !rule.value?.trim()
          )
        }
      />
    </div>
  );

  return (
    <Dialog
      visible={visible}
      onHide={onHide}
      header={editingFilter ? "Edit Filter" : "Create Filter"}
      style={{ width: "700px" }}
      modal
      footer={dialogFooter}
      className="p-fluid"
    >
      <div className="py-2">
        <div className="field mb-4">
          <label htmlFor="filterName" className="font-bold block mb-2">
            Filter Name *
          </label>
          <InputText
            id="filterName"
            value={filterName}
            onChange={(e) => setFilterName(e.target.value)}
            placeholder="Enter filter name"
          />
        </div>

        <div className="field mb-4">
          <label htmlFor="formSelect" className="font-bold block mb-2">
            Select Form *
          </label>
          <Dropdown
            id="formSelect"
            value={selectedForm}
            options={forms}
            onChange={handleFormChange}
            optionLabel="title"
            placeholder="Select a form"
            filter
            filterBy="title"
            disabled={!!editingFilter}
          />
        </div>

        {selectedForm && formFields.length > 0 && (
          <div className="rules-section">
            <div className="rules-section-header">
              <label className="font-bold">Filter Rules *</label>
              <Button
                label="Add Rule"
                icon="pi pi-plus"
                onClick={addRule}
                className="p-button-sm w-auto"
                style={{ backgroundColor: "#D97A07", borderColor: "#D97A07" }}
              />
            </div>

            {filterRules.map((rule, index) => (
              <div key={index} className="rule-row">
                <Dropdown
                  value={rule.field}
                  options={getAvailableFields(index)}
                  onChange={(e) => updateRule(index, "field", e.value)}
                  placeholder="Select field"
                  className="rule-field"
                  filter
                />
                <Dropdown
                  value={rule.operator}
                  options={operatorOptions}
                  onChange={(e) => updateRule(index, "operator", e.value)}
                  className="rule-operator"
                />
                {!["isEmpty", "isNotEmpty"].includes(rule.operator) && (
                  <InputText
                    value={rule.value}
                    onChange={(e) => updateRule(index, "value", e.target.value)}
                    placeholder="Value"
                    className="rule-value"
                  />
                )}
                {filterRules.length > 1 && (
                  <Button
                    icon="pi pi-trash"
                    onClick={() => removeRule(index)}
                    className="p-button-rounded p-button-danger p-button-text w-auto"
                  />
                )}
              </div>
            ))}
          </div>
        )}

        {loading && (
          <div className="flex justify-content-center p-4">
            <ProgressSpinner style={{ width: "30px", height: "30px" }} />
          </div>
        )}
      </div>
    </Dialog>
  );
};

export default FiltersDialog;
